<template>
  <nav class="menu-container">
    <h3><font color="#00AB39">1号线</font></h3>
    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
  </nav>
</template>

<script>
import Icon from "@/components/Icon";
export default {
  components: {
    Icon,
  },
  data() {
    return {
      items: [
        {
          name: "louhu",
          title: "罗湖",
          // icon: "chat",
          exact: true,
        },
        {
          name: "guomao",
          title: "国贸",
          // icon: "chat",
          exact: true,
        },
        {
          name: "laojie",
          title: "老街",
          // icon: "chat",
          exact: true,
        },
        {
          name: "dajuyuan",
          title: "大剧院",
          // icon: "chat",
          exact: true,
        },
        {
          name: "kexueguan",
          title: "科学馆",
          // icon: "chat",
          exact: true,
        },
        {
          name: "huaqianglu",
          title: "华强路",
          // icon: "chat",
          exact: true,
        },
        {
          name: "gangxia",
          title: "岗厦",
          // icon: "chat",
          exact: true,
        },
        {
          name: "huizhanzhongxin",
          title: "会展中心",
          // icon: "chat",
          exact: true,
        },
        {
          name: "gouwugongyuan",
          title: "购物公园",
          // icon: "chat",
          exact: true,
        },
        {
          name: "xiangmihu",
          title: "香蜜湖",
          // icon: "chat",
          exact: true,
        },
        {
          name: "chegongmiao",
          title: "车公庙",
          // icon: "chat",
          exact: true,
        },
        {
          name: "zhuzilin",
          title: "竹子林",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qiaochengdong",
          title: "侨城东",
          // icon: "chat",
          exact: true,
        },
        {
          name: "huaqiaocheng",
          title: "华侨城",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shijiezhichuang",
          title: "世界之窗",
          // icon: "chat",
          exact: true,
        },
        {
          name: "baishizhou",
          title: "白石洲",
          // icon: "chat",
          exact: true,
        },
        {
          name: "gaoxinyuan",
          title: "高新园",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shenda",
          title: "深大",
          // icon: "chat",
          exact: true,
        },
        {
          name: "taoyuan",
          title: "桃园",
          // icon: "chat",
          exact: true,
        },
        {
          name: "daxin",
          title: "大新",
          // icon: "chat",
          exact: true,
        },
        {
          name: "liyumen",
          title: "鲤鱼门",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qianhaiwan",
          title: "前海湾",
          // icon: "chat",
          exact: true,
        },
        {
          name: "xinan",
          title: "新安",
          // icon: "chat",
          exact: true,
        },
        {
          name: "baoanzhongxin",
          title: "宝安中心",
          // icon: "chat",
          exact: true,
        },
        {
          name: "baoti",
          title: "宝体",
          // icon: "chat",
          exact: true,
        },
        {
          name: "pingzhou",
          title: "坪洲",
          // icon: "chat",
          exact: true,
        },
        {
          name: "xixiang",
          title: "西乡",
          // icon: "chat",
          exact: true,
        },
        {
          name: "gushu",
          title: "固戍",
          // icon: "chat",
          exact: true,
        },
        {
          name: "hourui",
          title: "后瑞",
          // icon: "chat",
          exact: true,
        },
        {
          name: "jichangdong",
          title: "机场东",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(67, 47, 221);
    }
  }
}
</style>





<!-- <template>
  <div>
    <h3>
        首页<br><br>
深圳地铁1号线 途经站点 共30站<br><br>
注：高峰期发车间隔为4分钟，平峰期为6分钟<br><br>

罗湖站-国贸站-老街站-大剧院站-科学馆站-华强路站-岗厦站-会展中心站-购物公园站-香蜜湖站-车公庙站-竹子林站-侨城东站-华侨城站-世界之窗站-白石洲站-高新园站-深大站-桃园站-大新站-鲤鱼门站-前海湾站-新安站-宝安中心站- 宝体站-坪洲站-西乡站-固戍站-后瑞站-机场东站
    </h3>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style> -->